import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import {
  addMenuRecipeDetails,
  changeMenuValue,
  getMeasurementUnit,
  getRecipeCostPrice,
  getRecipeMultiplier,
  getRecipeUnitPrice,
  menuInitialValue,
  saveMenuRecipeDetails,
  saveStorageAreaDetails,
} from "../../../../Redux/actions";
import {
  checkNull,
  createSelectOptions,
  isNumeric,
  checkArray,
  decimalValue,
  getMerchantCurrencySymbol,
} from "../../../../helpers";
import ModelContainer from "../../../Components/ModelContainer";
import ErrorContainer from "../../../Components/ErrorContainer";
import GroupInput from "../../../Components/GroupInput";
import GroupTextArea from "../../../Components/GroupTextArea";
import GroupSelect from "../../../Components/GroupSelect";
import ListSelect from "../../../Components/ListSelect";
import ListInput from "../../../Components/ListInput";
const NewRecipe = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user_details = useSelector((state) => state.authReducer.user_details);
  const {
    recipe_details,
    storageAreaModalModal,
    is_add_storage_loading,
    add_storage_new_id,
    is_redirect_menu_recipe,
    ingreRecipeModal,
    measurement_unit_details,
  } = useSelector((state) => state.menuReducer);

  const recipeArrValidator = {
    category_id: yup.string().required(),
    ingredient_id: yup.string().required(),
    measurement_choice_id: yup.string().required(),
    amont_used_unit_id: yup.string().required(),
    temp_measurement_unit_id: yup.string().when("measurement_choice_id", {
      is: "2",
      then: yup.string().required(),
    }),
    temp_unit_price: yup.number().when("measurement_choice_id", {
      is: "2",
      then: yup.number().positive().required(),
    }),
    conversion_multiplier: yup.string().when("measurement_choice_id", {
      is: "2",
      then: yup.string().required(),
    }),
    unit_price: yup.number().positive().required(),
    amount_used: yup.number().positive().required(),
    // amont_used_unit_id: yup.string().required(),
    cost_per_recipe: yup.number().positive().required(),
    proportion: yup.number(),
  };

  const addRecipeSchema = yup
    .object({
      recipe_name: yup.string().required(),
      serving_amount: yup.string().required(),
      description: yup.string().required(),
      serving_unit_id: yup.string().required(),
      menu_class_id: yup.string().required(),
      storage_area_1_id: yup.string().required(),
      storage_area_2_id: yup.string().required(),
      notes: yup.string().required(),
      total_recipe_cost: yup.number().required(),
      number_of_servings: yup.number().required(),
      cost_per_serving: yup.number().required(),
      ingredients_recipe: yup
        .array()
        .of(yup.object().shape(recipeArrValidator)),
    })
    .required();

  useEffect(() => {
    dispatch(addMenuRecipeDetails());
    return () => {
      dispatch(menuInitialValue());
    };
  }, []);

  useEffect(() => {
    if (is_redirect_menu_recipe) {
      history.goBack();
    }
  }, [is_redirect_menu_recipe]);

  const initialIngreRecipeForm = {
    category_id: "",
    ingredient_id: "",
    measurement_choice_id: "",
    amont_used_unit_id: "",
    temp_measurement_unit_id: "",
    temp_unit_price: 0,
    conversion_multiplier: "",
    unit_price: 0,
    amount_used: 0,
    cost_per_recipe: 0,
    proportion: 0,
  };

  const initialAddRecipeForm = {
    recipe_name: "",
    serving_amount: "",
    description: "",
    serving_unit_id: "",
    menu_class_id: "",
    storage_area_1_id: "",
    storage_area_2_id: "",
    notes: "",
    total_recipe_cost: 0,
    number_of_servings: 0,
    cost_per_serving: 0,
    ingredients_recipe: [],
  };
  const [addRecipeInputForm, setAddRecipeInputForm] =
    useState(initialAddRecipeForm);

  const {
    register: addRecipeReg,
    formState: { errors: addRecipeErrors },
    handleSubmit: addRecipeSubmit,
    control: addRecipeControl,
    setValue: addRecipeSetValue,
    reset: addRecipeReset,
    trigger: addRecipeTrigger,
  } = useForm({
    resolver: yupResolver(addRecipeSchema),
    defaultValues: initialAddRecipeForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeAddRecipeInputHandler = (input, val) => {
    if (input == "storage_area_1_id" && val == "1") {
      setStorageAreaType(1);
      closeStorageAreaModal(true);
    } else if (input == "storage_area_2_id" && val == "1") {
      setStorageAreaType(2);
      closeStorageAreaModal(true);
    } else {
      addRecipeSetValue(input, val);
      setAddRecipeInputForm((prevState) => ({
        ...prevState,
        [input]: val,
      }));
    }
  };

  const addRecipeSubmitHandler = (data) => {
    data.total_recipe_cost = calculateTotalCostPrice();
    data.cost_per_serving = calculateCostPerServe();
    console.log("addRecipeSubmitHandler", data);
    dispatch(saveMenuRecipeDetails(data));
  };

  const getErrorMsgForAddRecipe = (input) => {
    let res = null;
    const errorMsg = addRecipeErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={addRecipeErrors} name={input} />;
    }
    return res;
  };

  // Ingredient Recipe
  const [selectedRecipeIndex, setSelectedRecipeIndex] = useState(-1);

  useEffect(() => {
    if (
      checkNull(recipe_details?.unit_price_detail?.measurement_price, false)
    ) {
      if (
        addRecipeInputForm?.ingredients_recipe?.[selectedRecipeIndex]
          ?.measurement_choice_id == 1
      ) {
        console.log(
          "ingreRecipeChangeInputHandler",
          selectedRecipeIndex,
          "unit_price",
          recipe_details?.unit_price_detail?.measurement_price
        );
        ingreRecipeChangeInputHandler(
          selectedRecipeIndex,
          "unit_price",
          recipe_details?.unit_price_detail?.measurement_price
        );
      } else {
        ingreRecipeChangeInputHandler(
          selectedRecipeIndex,
          "temp_unit_price",
          recipe_details?.unit_price_detail?.measurement_price
        );
      }
    }
  }, [recipe_details?.unit_price_detail]);

  useEffect(() => {
    if (checkNull(recipe_details?.multiplier_detail?.multiplier, false)) {
      ingreRecipeChangeInputHandler(
        selectedRecipeIndex,
        "conversion_multiplier",
        recipe_details?.multiplier_detail?.multiplier
      );
    }
  }, [recipe_details?.multiplier_detail]);

  useEffect(() => {
    if (checkNull(recipe_details?.cpr_detail?.cpr, false)) {
      ingreRecipeChangeInputHandler(
        selectedRecipeIndex,
        "cost_per_recipe",
        recipe_details?.cpr_detail?.cpr
      );
    }
  }, [recipe_details?.cpr_detail]);

  useEffect(() => {
    if (checkNull(measurement_unit_details, false)) {
      if (checkNull(measurement_unit_details?.category, false)) {
        Object.keys(measurement_unit_details?.category).map((categoryVal) => {
          ingreRecipeChangeInputHandler(
            selectedRecipeIndex,
            "category_id",
            categoryVal
          );
        });
      }
    }
  }, [measurement_unit_details]);

  const initialIngreRecipeModalState = () => {
    const newRecipeDetail = { ...recipe_details };
    newRecipeDetail.unit_price_detail = null;
    newRecipeDetail.cpr_detail = null;
    newRecipeDetail.multiplier_detail = null;
    dispatch(changeMenuValue("recipe_details", newRecipeDetail));
  };

  const closeIngreRecipeModal = useCallback(
    (value, isSave = false) => {
      dispatch(changeMenuValue("ingreRecipeModal", value));
      // initialIngreRecipeModalState();
      if (value) {
        addToIngreRecipe();
      } else if (!value && !isSave) {
        addToIngreRecipe(true);
      }
    },
    [ingreRecipeModal, addRecipeInputForm, selectedRecipeIndex]
  );

  const addToIngreRecipe = (isDelete = false) => {
    const newConvObj = [...addRecipeInputForm.ingredients_recipe];
    if (isDelete) {
      newConvObj.pop();
      setSelectedRecipeIndex("");
    } else {
      newConvObj.push(initialIngreRecipeForm);
      const totalConvLength = addRecipeInputForm.ingredients_recipe.length;
      setSelectedRecipeIndex(totalConvLength);
    }
    changeAddRecipeInputHandler("ingredients_recipe", newConvObj);
  };

  async function submitIngreRecipeModal() {
    const lastIndex = selectedRecipeIndex;
    const result = await addRecipeTrigger([
      `ingredients_recipe.${lastIndex}.category_id`,
      `ingredients_recipe.${lastIndex}.ingredient_id`,
      `ingredients_recipe.${lastIndex}.measurement_choice_id`,
      `ingredients_recipe.${lastIndex}.amont_used_unit_id`,
      `ingredients_recipe.${lastIndex}.temp_measurement_unit_id`,
      `ingredients_recipe.${lastIndex}.temp_unit_price`,
      `ingredients_recipe.${lastIndex}.conversion_multiplier`,
      `ingredients_recipe.${lastIndex}.unit_price`,
      `ingredients_recipe.${lastIndex}.amount_used`,
      `ingredients_recipe.${lastIndex}.cost_per_recipe`,
      `ingredients_recipe.${lastIndex}.proportion`,
    ]);
    if (result) {
      calculateAllRecipePortion();
      closeIngreRecipeModal(false, true);
    }
  }

  const ingreRecipeChangeInputHandler = (index, type, value) => {
    const checkIngreConv = addRecipeInputForm?.ingredients_recipe?.[index];
    let newIngreConv = { ...initialIngreRecipeForm };
    if (checkNull(checkIngreConv, false)) {
      if (type == "ingredient_id") {
        newIngreConv.category_id = checkIngreConv.category_id;
        newIngreConv.ingredient_id = value;
        if (checkNull(value, false)) dispatch(getMeasurementUnit(`/${value}`));
      } else {
        newIngreConv = { ...checkIngreConv, [type]: value };
        // get unit price
        if (type == "amont_used_unit_id") {
          if (checkNull(checkIngreConv?.measurement_choice_id, false)) {
            if (checkIngreConv?.measurement_choice_id == 1) {
              if (
                checkNull(value, false) &&
                checkNull(checkIngreConv?.ingredient_id, false)
              ) {
                dispatch(
                  getRecipeUnitPrice({
                    mu_id: value,
                    ing_id: checkIngreConv?.ingredient_id,
                  })
                );
              } else {
                newIngreConv.unit_price = 0;
              }
            } else if (
              checkNull(checkIngreConv?.temp_measurement_unit_id, false) &&
              isNumeric(checkIngreConv?.temp_measurement_unit_id)
            ) {
              dispatch(
                getRecipeMultiplier({
                  from_id: checkIngreConv?.temp_measurement_unit_id,
                  to_id: value,
                })
              );
            }
          }
        }
        if (type == "temp_measurement_unit_id") {
          if (checkNull(checkIngreConv?.measurement_choice_id, false)) {
            if (checkIngreConv?.measurement_choice_id == 2) {
              if (
                checkNull(value, false) &&
                checkNull(checkIngreConv?.ingredient_id, false)
              ) {
                dispatch(
                  getRecipeUnitPrice({
                    mu_id: value,
                    ing_id: checkIngreConv?.ingredient_id,
                  })
                );
              } else {
                newIngreConv.temp_unit_price = 0;
              }
            }
          }
        }
        if (type == "conversion_multiplier") {
          if (checkNull(checkIngreConv?.measurement_choice_id, false)) {
            if (checkIngreConv?.measurement_choice_id == 2) {
              if (
                checkNull(value, false) &&
                isNumeric(value) &&
                checkNull(checkIngreConv?.temp_unit_price, false) &&
                isNumeric(checkIngreConv?.temp_unit_price)
              ) {
                newIngreConv.unit_price = parseFloat(
                  parseFloat(value) *
                    parseFloat(checkIngreConv?.temp_unit_price)
                ).toFixed(2);
              } else {
                newIngreConv.unit_price = 0;
              }
            }
          }
        }
        // get unit price END
        // get cost price
        if (type == "amount_used") {
          if (checkNull(checkIngreConv?.measurement_choice_id, false)) {
            if (checkIngreConv?.measurement_choice_id == 1) {
              if (
                checkNull(value, false) &&
                isNumeric(value) &&
                checkNull(checkIngreConv?.ingredient_id, false) &&
                checkNull(checkIngreConv?.amont_used_unit_id, false)
              ) {
                dispatch(
                  getRecipeCostPrice({
                    amount: value,
                    mu_id: checkIngreConv?.amont_used_unit_id,
                    ing_id: checkIngreConv?.ingredient_id,
                  })
                );
              } else {
                newIngreConv.cost_per_recipe = 0;
                newIngreConv.proportion = 0;
              }
            } else {
              if (
                checkNull(value, false) &&
                isNumeric(value) &&
                checkNull(checkIngreConv?.unit_price, false) &&
                isNumeric(checkIngreConv?.unit_price)
              ) {
                const newCostPrice = parseFloat(
                  parseFloat(value) * parseFloat(checkIngreConv?.unit_price)
                ).toFixed(2);
                newIngreConv.cost_per_recipe = newCostPrice;
              } else {
                newIngreConv.cost_per_recipe = 0;
              }
            }
          }
        }
        // get cost price END
      }

      const addIngreConv = [...addRecipeInputForm.ingredients_recipe];
      addIngreConv[index] = newIngreConv;
      changeAddRecipeInputHandler("ingredients_recipe", addIngreConv);
    }
  };

  const calculateTotalCostPrice = (
    recipeArr = addRecipeInputForm?.ingredients_recipe
  ) => {
    let res = 0;
    if (checkArray(recipeArr)) {
      res = recipeArr.reduce(
        (sum, current) => sum + parseFloat(current.cost_per_recipe ?? 0),
        0
      );
    }
    return res;
  };
  const calculateCostPerServe = (
    recipeArr = addRecipeInputForm?.ingredients_recipe
  ) => {
    let res = 0;
    if (
      checkArray(recipeArr) &&
      checkNull(addRecipeInputForm?.number_of_servings, false)
    ) {
      const totalCost = calculateTotalCostPrice(recipeArr);
      const noOfServing = parseFloat(addRecipeInputForm?.number_of_servings);
      res = totalCost / noOfServing;
    }
    return res;
  };

  const calculatePortion = (
    crpVal = 0,
    recipeArr = addRecipeInputForm?.ingredients_recipe
  ) => {
    const totalCostPrice = calculateTotalCostPrice(recipeArr);
    return (parseFloat(crpVal) / totalCostPrice) * 100;
  };

  const calculateAllRecipePortion = (
    recipeArr = addRecipeInputForm?.ingredients_recipe
  ) => {
    if (checkArray(recipeArr)) {
      const newIngredientsRecipeArr = [...recipeArr];
      newIngredientsRecipeArr.map((newRec) => {
        newRec.proportion = calculatePortion(
          newRec?.cost_per_recipe ?? 0,
          recipeArr
        );
      });
      changeAddRecipeInputHandler(
        "ingredients_recipe",
        newIngredientsRecipeArr
      );
    }
  };

  const editIngreRecHandler = (convIdx) => {
    const ingredientId =
      addRecipeInputForm?.ingredients_recipe?.[convIdx]?.ingredient_id ?? "";
    dispatch(getMeasurementUnit(`/${ingredientId}`));
    setSelectedRecipeIndex(convIdx);
    dispatch(changeMenuValue("ingreRecipeModal", true));
  };
  const deleteIngreRecHandler = (convIdx) => {
    if (addRecipeInputForm?.ingredients_recipe?.[convIdx]) {
      const addIngreConv = [...addRecipeInputForm.ingredients_recipe];
      addIngreConv.splice(convIdx, 1);
      changeAddRecipeInputHandler("ingredients_recipe", addIngreConv);
      calculateAllRecipePortion(addIngreConv);
    }
  };

  const getErrorMsgForIngreRecipe = (input) => {
    const index = selectedRecipeIndex;
    let res = null;
    const errorMsg = addRecipeErrors?.ingredients_recipe?.[index]?.[input];
    if (errorMsg && checkNull(errorMsg?.message)) {
      res = <ErrorContainer message={errorMsg?.message} name={input} />;
    }
    return res;
  };

  /* Storage Area Popups */
  useEffect(() => {
    setStorageAreaInput("");
    setStorageAreaType(1);
  }, [storageAreaModalModal]);
  useEffect(() => {
    if (checkNull(add_storage_new_id, false)) {
      changeAddRecipeInputHandler(
        storageAreaType == 1 ? "storage_area_1_id" : "storage_area_2_id",
        `${add_storage_new_id}`
      );
    }
  }, [add_storage_new_id]);

  const [storageAreaInput, setStorageAreaInput] = useState("");
  const [storageAreaType, setStorageAreaType] = useState(1);

  const closeStorageAreaModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("storageAreaModalModal", value));
    },
    [storageAreaModalModal]
  );

  const submitStorageAreaModal = () => {
    dispatch(
      saveStorageAreaDetails({ type: storageAreaType, name: storageAreaInput })
    );
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        {console.log("addRecipeInputForm", addRecipeInputForm)}
        {console.log("addRecipeErrors", addRecipeErrors)}
        <div className="inner-content row mx-0 finance-setting-chart recipe_info">
          <div className="container px-0">
            <div class="row">
              <div className="col-lg-9 col-12 d-flex">
                <div className="shadowclass my-lg-4 mt-4 mb-2">
                  <h4 class="event-alert">Recipe Info </h4>
                  <div class="row mx-0">
                    <div class="col-lg-6 col-12 px-sm-3 px-0">
                      <ul class="ingredient-info edit-shift">
                        <GroupInput
                          label={"Recipe Name"}
                          labelClass="required"
                          name="recipe_name"
                          className="required"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "recipe_name",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.recipe_name}
                          errorMsg={getErrorMsgForAddRecipe("recipe_name")}
                        />
                        <GroupTextArea
                          label={"Description"}
                          name="description"
                          className="required"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "description",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.description}
                          errorMsg={getErrorMsgForAddRecipe("description")}
                        />
                        <GroupSelect
                          label={"Category"}
                          name="menu_class_id"
                          className="required"
                          labelClass="required"
                          divClass="input-group"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "menu_class_id",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.menu_class_id}
                          options={createSelectOptions(recipe_details?.classes)}
                          errorMsg={getErrorMsgForAddRecipe("menu_class_id")}
                        />
                        <GroupSelect
                          label={"Storage Area #1"}
                          name="storage_area_1_id"
                          className="required"
                          divClass="input-group"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "storage_area_1_id",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.storage_area_1_id}
                          options={createSelectOptions(
                            recipe_details?.storage_area
                          )}
                          errorMsg={getErrorMsgForAddRecipe(
                            "storage_area_1_id"
                          )}
                        />
                        <GroupSelect
                          label={"Storage Area #2"}
                          name="storage_area_2_id"
                          className="required"
                          divClass="input-group"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "storage_area_2_id",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.storage_area_2_id}
                          options={createSelectOptions(
                            recipe_details?.storage_area
                          )}
                          errorMsg={getErrorMsgForAddRecipe(
                            "storage_area_2_id"
                          )}
                        />
                      </ul>
                    </div>

                    <div class="col-lg-6 col-12 px-sm-3 px-0">
                      <ul class="ingredient-info edit-shift">
                        <GroupInput
                          label={"Serving Amount"}
                          labelClass="required"
                          name="serving_amount"
                          className="required"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "serving_amount",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.serving_amount}
                          errorMsg={getErrorMsgForAddRecipe("serving_amount")}
                        />
                        <GroupInput
                          label={"Serving Unit"}
                          labelClass="required"
                          name="serving_unit_id"
                          className="required"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "serving_unit_id",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.serving_unit_id}
                          errorMsg={getErrorMsgForAddRecipe("serving_unit_id")}
                        />
                        <GroupTextArea
                          label={"Notes"}
                          name="notes"
                          className="required"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "notes",
                              e?.target?.value
                            )
                          }
                          value={addRecipeInputForm?.notes}
                          errorMsg={getErrorMsgForAddRecipe("notes")}
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-12 d-flex">
                <div class="shadowclass my-lg-4 my-2">
                  <h4 class="event-alert">Financial Details</h4>
                  <ul class="financial-detail">
                    <li>
                      <label>Total Recipe Cost</label>
                      <input
                        type="hidden"
                        name="data[Recipe][total_recipe_cost]"
                        id="RecipeTotalRecipeCost"
                      />
                      <span id="tot_rec_cost">
                        <strong>
                          {getMerchantCurrencySymbol(user_details)}
                        </strong>
                        {parseFloat(calculateTotalCostPrice()).toFixed(2)}
                      </span>
                    </li>
                    <li>
                      <label class="required">Number of Servings</label>
                      <div class="no-saving">
                        <input
                          name="data[Recipe][number_of_servings]"
                          class="required number number_format"
                          type="text"
                          id="RecipeNumberOfServings"
                          onChange={(e) =>
                            changeAddRecipeInputHandler(
                              "number_of_servings",
                              parseInt(e?.target?.value)
                            )
                          }
                          value={addRecipeInputForm?.number_of_servings}
                        />
                      </div>
                    </li>
                    <li>
                      <label>Cost Per Serving</label>
                      <span id="cost_per_serving">
                        <strong>
                          {getMerchantCurrencySymbol(user_details)}
                        </strong>
                        {parseFloat(calculateCostPerServe()).toFixed(2)}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Recipe List</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th>Category</th>
                                <th>Recipe Name</th>
                                <th>Amount Used Per Recipe</th>
                                <th>Cost Per Recipe</th>
                                <th>Proportion of Cost</th>
                                <th className="action-td">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(
                                addRecipeInputForm?.ingredients_recipe
                              ) &&
                                addRecipeInputForm?.ingredients_recipe.map(
                                  (recipe, recIndx) => {
                                    return (
                                      <tr>
                                        <td class="">
                                          {checkNull(
                                            recipe_details?.ingredients?.[
                                              recipe?.ingredient_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(
                                            recipe_details
                                              ?.measurementChoices?.[
                                              recipe?.measurement_choice_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {decimalValue(
                                            recipe?.amount_used,
                                            4,
                                            ""
                                          )}{" "}
                                          {checkNull(
                                            recipe_details
                                              ?.servingUnits_only_name?.[
                                              recipe?.amont_used_unit_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {decimalValue(
                                            recipe?.cost_per_recipe,
                                            2,
                                            getMerchantCurrencySymbol(
                                              user_details
                                            )
                                          )}
                                        </td>
                                        <td>
                                          {decimalValue(
                                            recipe?.proportion,
                                            2,
                                            ""
                                          )}
                                          %
                                        </td>
                                        <td>
                                          <div class="event-time-edit p0">
                                            <a
                                              class="editComponent"
                                              onClick={() =>
                                                editIngreRecHandler(recIndx)
                                              }
                                            >
                                              <i class="iconSprites edit-icon"></i>
                                            </a>
                                            <a
                                              class="circle_icon"
                                              onClick={() =>
                                                deleteIngreRecHandler(recIndx)
                                              }
                                            >
                                              <i class="iconSprites delete-icon"></i>
                                            </a>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>

                        <div class="my-3">
                          <button
                            class="btn green-btn-revert add-plus addSp"
                            id="addCount"
                            type="button"
                            onClick={() => closeIngreRecipeModal(true)}
                          >
                            <i class="i-icon"> </i> Add Recipe List
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-0">
          <div class="container px-0 d-flex col-12">
            <form onSubmit={addRecipeSubmit(addRecipeSubmitHandler)} className="w-100">
              <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                <button type="submit">Save</button>
                <button
                  id="cancel"
                  onClick={() => history.goBack()}
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Add Ingredient`}
        open={ingreRecipeModal}
        submitModal={submitIngreRecipeModal}
        closeModal={closeIngreRecipeModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <ListSelect
              label={"Ingredient"}
              name="ingredient_id"
              className="required select2-offscreen"
              onChange={(e) =>
                ingreRecipeChangeInputHandler(
                  selectedRecipeIndex,
                  "ingredient_id",
                  e?.target?.value
                )
              }
              value={
                addRecipeInputForm?.ingredients_recipe?.[selectedRecipeIndex]
                  ?.ingredient_id
              }
              options={createSelectOptions(recipe_details?.ingredients)}
              errorMsg={
                getErrorMsgForIngreRecipe("ingredient_id") ||
                getErrorMsgForIngreRecipe("category_id")
              }
            />
            <ListSelect
              label={"Measurement Choice"}
              name="measurement_choice_id"
              className="required select2-offscreen"
              onChange={(e) =>
                ingreRecipeChangeInputHandler(
                  selectedRecipeIndex,
                  "measurement_choice_id",
                  e?.target?.value
                )
              }
              value={
                addRecipeInputForm?.ingredients_recipe?.[selectedRecipeIndex]
                  ?.measurement_choice_id
              }
              options={createSelectOptions(recipe_details?.measurementChoices)}
              errorMsg={getErrorMsgForIngreRecipe("measurement_choice_id")}
            />
            {addRecipeInputForm?.ingredients_recipe?.[selectedRecipeIndex]
              ?.measurement_choice_id == 1 && (
              <>
                <ListSelect
                  label={"Measurement Unit"}
                  name="amont_used_unit_id"
                  className="required select2-offscreen"
                  onChange={(e) =>
                    ingreRecipeChangeInputHandler(
                      selectedRecipeIndex,
                      "amont_used_unit_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.amont_used_unit_id
                  }
                  options={createSelectOptions(measurement_unit_details?.units)}
                  errorMsg={getErrorMsgForIngreRecipe("amont_used_unit_id")}
                />
                <ListInput
                  label={"Unit Price"}
                  name="unit_price"
                  className="number required"
                  placeholder="Unit Price"
                  // onChange={(e) =>
                  //   ingreRecipeChangeInputHandler(
                  //     selectedRecipeIndex,
                  //     "unit_price",
                  //     e?.target?.value
                  //   )
                  // }
                  readOnly={true}
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.unit_price
                  }
                  errorMsg={getErrorMsgForIngreRecipe("unit_price")}
                />
                <ListInput
                  label={"Amount Used Per Recipe"}
                  name="amount_used"
                  className="number required"
                  placeholder="Amount Used Per Recipe"
                  onChange={(e) =>
                    ingreRecipeChangeInputHandler(
                      selectedRecipeIndex,
                      "amount_used",
                      e?.target?.value
                    )
                  }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.amount_used
                  }
                  errorMsg={getErrorMsgForIngreRecipe("amount_used")}
                />
                <ListInput
                  label={"Total Cost"}
                  name="cost_per_recipe"
                  className="number required"
                  placeholder="Total Cost"
                  readOnly={true}
                  // onChange={(e) =>
                  //   ingreRecipeChangeInputHandler(
                  //     selectedRecipeIndex,
                  //     "cost_per_recipe",
                  //     e?.target?.value
                  //   )
                  // }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.cost_per_recipe
                  }
                  errorMsg={getErrorMsgForIngreRecipe("cost_per_recipe")}
                />
              </>
            )}
            {addRecipeInputForm?.ingredients_recipe?.[selectedRecipeIndex]
              ?.measurement_choice_id == 2 && (
              <>
                <h5 class="top_no_bot">Inventory Measurement Amount</h5>
                <ListSelect
                  label={"Measurement Unit"}
                  name="temp_measurement_unit_id"
                  className="required select2-offscreen"
                  onChange={(e) =>
                    ingreRecipeChangeInputHandler(
                      selectedRecipeIndex,
                      "temp_measurement_unit_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.temp_measurement_unit_id
                  }
                  options={createSelectOptions(measurement_unit_details?.units)}
                  errorMsg={getErrorMsgForIngreRecipe(
                    "temp_measurement_unit_id"
                  )}
                />
                {/* TODO */}
                <ListInput
                  label={"Unit Price"}
                  name="temp_unit_price"
                  className="number required"
                  placeholder="Unit Price"
                  // onChange={(e) =>
                  //   ingreRecipeChangeInputHandler(
                  //     selectedRecipeIndex,
                  //     "temp_unit_price",
                  //     e?.target?.value
                  //   )
                  // }
                  readOnly={true}
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.temp_unit_price
                  }
                  errorMsg={getErrorMsgForIngreRecipe("temp_unit_price")}
                />
                <ListInput
                  label={"Conversion Multiplier"}
                  name="conversion_multiplier"
                  className="number required"
                  placeholder="Conversion Multiplier"
                  onChange={(e) => {
                    if (
                      checkNull(
                        recipe_details?.multiplier_detail?.multiplier,
                        false
                      ) === false
                    ) {
                      ingreRecipeChangeInputHandler(
                        selectedRecipeIndex,
                        "conversion_multiplier",
                        e?.target?.value
                      );
                    }
                  }}
                  readOnly={
                    checkNull(
                      recipe_details?.multiplier_detail?.multiplier,
                      false
                    )
                      ? true
                      : false
                  }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.conversion_multiplier
                  }
                  errorMsg={getErrorMsgForIngreRecipe("conversion_multiplier")}
                />
                <h5 class="top_no_bot">Recipe Measurement Amount </h5>
                <ListSelect
                  label={"Measurement Unit"}
                  name="amont_used_unit_id"
                  className="required select2-offscreen"
                  onChange={(e) =>
                    ingreRecipeChangeInputHandler(
                      selectedRecipeIndex,
                      "amont_used_unit_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.amont_used_unit_id
                  }
                  options={createSelectOptions(
                    recipe_details?.servingUnits_only_name
                  )}
                  errorMsg={getErrorMsgForIngreRecipe("amont_used_unit_id")}
                />
                <ListInput
                  label={"Unit Price"}
                  name="unit_price"
                  className="number required"
                  placeholder="Unit Price"
                  // onChange={(e) =>
                  //   ingreRecipeChangeInputHandler(
                  //     selectedRecipeIndex,
                  //     "unit_price",
                  //     e?.target?.value
                  //   )
                  // }
                  readOnly={true}
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.unit_price
                  }
                  errorMsg={getErrorMsgForIngreRecipe("unit_price")}
                />
                <ListInput
                  label={"Amount Used Per Recipe"}
                  name="amount_used"
                  className="number required"
                  placeholder="Amount Used Per Recipe"
                  onChange={(e) =>
                    ingreRecipeChangeInputHandler(
                      selectedRecipeIndex,
                      "amount_used",
                      e?.target?.value
                    )
                  }
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.amount_used
                  }
                  errorMsg={getErrorMsgForIngreRecipe("amount_used")}
                />
                <ListInput
                  label={"Total Cost"}
                  name="cost_per_recipe"
                  className="number required"
                  placeholder="Total Cost"
                  // onChange={(e) =>
                  //   ingreRecipeChangeInputHandler(
                  //     selectedRecipeIndex,
                  //     "cost_per_recipe",
                  //     e?.target?.value
                  //   )
                  // }
                  readOnly={true}
                  value={
                    addRecipeInputForm?.ingredients_recipe?.[
                      selectedRecipeIndex
                    ]?.cost_per_recipe
                  }
                  errorMsg={getErrorMsgForIngreRecipe("cost_per_recipe")}
                />
              </>
            )}
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Storage Area`}
        open={storageAreaModalModal}
        submitModal={submitStorageAreaModal}
        closeModal={closeStorageAreaModal}
        is_loading={is_add_storage_loading}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <li>
              Storage Area
              <div class="input-group">
                <input
                  name="data[storage_area]"
                  class="required"
                  type="text"
                  id="storage_area"
                  onChange={(e) => setStorageAreaInput(e?.target?.value)}
                  value={storageAreaInput}
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>
    </UserInterface>
  );
};
export default NewRecipe;
